import groq from 'groq';

import { ASSET, DURATION, SLUG } from '../common';

export const BLOG_CARD = groq`
  _id,
  "type": _type,
  categories,
  ${SLUG},
  title,
  ${DURATION},
  heroImage { ${ASSET} },
  heroVideoUrl,
  publishedAt,
  summary
`;
